"use client";

import { BundleProductsListUI } from "./BundleProductsListUI";
import { StandardProps } from "../componentMap";
import { useRouter } from "next/router";

export const BundleProductsList = ({
  product,
}: Pick<StandardProps, "product">) => {
  const router = useRouter();

  const variant = product.variants[0];
  if (variant?.__typename !== "RetiredStaticBundleVariant") return null;

  const navigate = (url: string) => {
    router.push(url, undefined, { shallow: true, scroll: false });
  };

  return (
    <BundleProductsListUI
      bundleComponents={variant.components}
      navigate={navigate}
    />
  );
};
